<pre *ngIf="debugMapping">{{ mapping | json }}</pre>
<div style="margin-bottom: 1em;">
  <mat-error *ngIf="hasError">
    Mapping error: {{ errorMessage }}
  </mat-error>
</div>
